import React from "react";
import {Text, StyleSheet} from "react-native";
import {isLoaded} from 'expo-font';
import {styleVars} from "../../../app-style-vars";
import {PtIconProps} from './pt-icon-props';

export default function PtIcon(props: PtIconProps) {
  const iconName = props.iconName || '';
  const iconSize = props.iconSize || styleVars.rem(1.5);
  const iconColor = props.iconColor || '#000';

  const iconsMap = {
    '3d-print': '\ue085',
    'a-to-b': '\ue086',
    'add': '\ue087',
    'address-consumer-data': '\ue088',
    'adress-book': '\ue089',
    'agility': '\ue08a',
    'alarm-clock': '\ue08b',
    'ambulance': '\ue08c',
    'analysis': '\ue08d',
    'anchor': '\ue08e',
    'arrow-down': '\ue08f',
    'arrow-left': '\ue090',
    'arrow-left-down': '\ue091',
    'arrow-left-up': '\ue092',
    'arrow-right': '\ue093',
    'arrow-right-down': '\ue094',
    'arrow-right-up': '\ue095',
    'arrow-turn-left': '\ue096',
    'arrow-turn-right': '\ue097',
    'arrow-up': '\ue098',
    'arrows': '\ue099',
    'arrows-x-y-z': '\ue09a',
    'artificial-intelligence': '\ue09b',
    'assembly-line': '\ue09c',
    'atom': '\ue09d',
    'augmented-reality': '\ue09e',
    'autobod': '\ue09f',
    'back-left': '\ue0a0',
    'back-left-double': '\ue0a1',
    'bar-chart': '\ue0a2',
    'bar-chart-double': '\ue0a3',
    'battery-0': '\ue0a4',
    'battery-1': '\ue0a5',
    'battery-2': '\ue0a6',
    'battery-3': '\ue0a7',
    'battery-4': '\ue0a8',
    'battery-fail': '\ue0a9',
    'battery-li-ion': '\ue0aa',
    'battery-loading': '\ue0ab',
    'bed': '\ue0ac',
    'bicycle': '\ue0ad',
    'bicycle-e': '\ue0ae',
    'blog': '\ue0af',
    'bluetooth': '\ue0b0',
    'bluetooth-le': '\ue0b1',
    'board-speaker': '\ue0b2',
    'boiler-connected': '\ue0b3',
    'book': '\ue0b4',
    'bookmark': '\ue0b5',
    'bookmark-add': '\ue0b6',
    'bookmark-check': '\ue0b7',
    'bookmark-delete': '\ue0b8',
    'books': '\ue0b9',
    'bookshelf': '\ue0ba',
    'box': '\ue0bb',
    'box-closed': '\ue0bc',
    'box-delivery': '\ue0bd',
    'box-delivery-connected': '\ue0be',
    'brake-disk': '\ue0bf',
    'briefcase': '\ue0c0',
    'broom': '\ue0c1',
    'broom-cloud-dirt': '\ue0c2',
    'brush': '\ue0c3',
    'bug': '\ue0c4',
    'building': '\ue0c5',
    'cactus': '\ue0c6',
    'calculate': '\ue0c7',
    'calendar': '\ue0c8',
    'calendar-add': '\ue0c9',
    'calendar-settings': '\ue0ca',
    'call': '\ue0cb',
    'call-add': '\ue0cc',
    'call-remove': '\ue0cd',
    'call-sos': '\ue0ce',
    'call-team': '\ue0cf',
    'call-wifi': '\ue0d0',
    'camera': '\ue0d1',
    'camera-switch': '\ue0d2',
    'car': '\ue0d3',
    'car-clock': '\ue0d4',
    'car-connected': '\ue0d5',
    'car-locator': '\ue0d6',
    'car-mechanic': '\ue0d7',
    'car-rental': '\ue0d8',
    'car-seat-connected': '\ue0d9',
    'car-side': '\ue0da',
    'car-side-user': '\ue0db',
    'cart': '\ue0dc',
    'certificate': '\ue0dd',
    'certificate-pki': '\ue0de',
    'change': '\ue0df',
    'chart-bar': '\ue0e0',
    'chart-check': '\ue0e1',
    'chart-dummy': '\ue0e2',
    'chart-line': '\ue0e3',
    'chat': '\ue0e4',
    'chat-add': '\ue0e5',
    'chat-question-answer': '\ue0e6',
    'chat-remove': '\ue0e7',
    'checklist': '\ue0e8',
    'checkmark': '\ue0e9',
    'chip': '\ue0ea',
    'circle-segment': '\ue0eb',
    'clear-all': '\ue0ec',
    'clipboard': '\ue0ed',
    'clipboard-list': '\ue0ee',
    'clock': '\ue0ef',
    'close': '\ue0f0',
    'close-all': '\ue0f1',
    'cloud': '\ue0f2',
    'cloud-co2': '\ue0f3',
    'cloud-download': '\ue0f4',
    'cloud-nox': '\ue0f5',
    'cloud-upload': '\ue0f6',
    'club-arm-chair': '\ue0f7',
    'coffee-break': '\ue0f8',
    'coin-currency': '\ue0f9',
    'coin-dollar': '\ue0fa',
    'colorpicker': '\ue0fb',
    'colors': '\ue0fc',
    'command': '\ue0fd',
    'communicator': '\ue0fe',
    'compare': '\ue0ff',
    'components': '\ue100',
    'components-available': '\ue101',
    'components-reservation': '\ue102',
    'concierge-bell': '\ue103',
    'configuration': '\ue104',
    'confirmation': '\ue105',
    'connection-off': '\ue106',
    'connection-on': '\ue107',
    'connectivity': '\ue108',
    'construction': '\ue109',
    'consumer-goods': '\ue10a',
    'contract': '\ue10b',
    'copy': '\ue10c',
    'cube': '\ue10d',
    'cube-arrows': '\ue10e',
    'cube-filled': '\ue10f',
    'cube-shock': '\ue110',
    'cube-stacked': '\ue111',
    'customerservice': '\ue112',
    'cutlery': '\ue113',
    'damper': '\ue114',
    'danger-flash': '\ue115',
    'data-loss': '\ue116',
    'dealer-details': '\ue117',
    'delete': '\ue118',
    'delivery': '\ue119',
    'denied': '\ue11a',
    'desktop': '\ue11b',
    'desktop-application-2d': '\ue11c',
    'desktop-application-3d': '\ue11d',
    'development': '\ue11e',
    'devices': '\ue11f',
    'devices-mobile': '\ue120',
    'directory': '\ue121',
    'dna': '\ue122',
    'do-not-disturb': '\ue123',
    'document': '\ue124',
    'document-add': '\ue125',
    'document-arrow-down': '\ue126',
    'document-arrow-up': '\ue127',
    'document-audio': '\ue128',
    'document-check': '\ue129',
    'document-cloud': '\ue12a',
    'document-copy': '\ue12b',
    'document-delete': '\ue12c',
    'document-doc': '\ue12d',
    'document-edit': '\ue12e',
    'document-error': '\ue12f',
    'document-locked': '\ue130',
    'document-log': '\ue131',
    'document-one': '\ue132',
    'document-pdf': '\ue133',
    'document-plain': '\ue134',
    'document-plain-add': '\ue135',
    'document-plain-delete': '\ue136',
    'document-ppt': '\ue137',
    'document-pub': '\ue138',
    'document-rtf': '\ue139',
    'document-save-to': '\ue13a',
    'document-search': '\ue13b',
    'document-settings': '\ue13c',
    'document-test': '\ue13d',
    'document-text': '\ue13e',
    'document-txt': '\ue13f',
    'document-vsd': '\ue140',
    'document-xls': '\ue141',
    'document-xml': '\ue142',
    'document-zip': '\ue143',
    'dome': '\ue144',
    'door': '\ue145',
    'door-sensor': '\ue146',
    'down': '\ue147',
    'down-double': '\ue148',
    'download': '\ue149',
    'drag-handle': '\ue14a',
    'dragdrop': '\ue14b',
    'drop': '\ue14c',
    'e-charging': '\ue14d',
    'e-mobility': '\ue14e',
    'ear-off-disabled-light': '\ue14f',
    'ear-on': '\ue150',
    'eco-system': '\ue151',
    'edit': '\ue152',
    'education': '\ue153',
    'efficiency': '\ue154',
    'elevator': '\ue155',
    'elevator-alarm': '\ue156',
    'elevator-cloud': '\ue157',
    'elevator-headset': '\ue158',
    'elevator-service': '\ue159',
    'emergency-exit': '\ue15a',
    'emoji-happy': '\ue15b',
    'emoji-neutral': '\ue15c',
    'emoji-sad': '\ue15d',
    'emoji-super-happy': '\ue15e',
    'emoji-very-sad': '\ue15f',
    'eu-energy-label': '\ue160',
    'excavator': '\ue161',
    'no-icon': '\ue162',
    'exit': '\ue163',
    'expansion-arrows': '\ue164',
    'explosion': '\ue165',
    'export': '\ue166',
    'externallink': '\ue167',
    'fast-forward': '\ue168',
    'faucet': '\ue169',
    'favorites': '\ue16a',
    'fax': '\ue16b',
    'female': '\ue16c',
    'film': '\ue16d',
    'filter': '\ue16e',
    'filter-success': '\ue16f',
    'fingerprint': '\ue170',
    'fire': '\ue171',
    'fire-emergency': '\ue172',
    'fireworks': '\ue173',
    'first-aid': '\ue174',
    'first-aid-cross': '\ue175',
    'fit-to-sceen': '\ue176',
    'flag': '\ue177',
    'flash': '\ue178',
    'flask': '\ue179',
    'flexpress': '\ue17a',
    'folder': '\ue17b',
    'folder-download': '\ue17c',
    'folder-open': '\ue17d',
    'folder-upload': '\ue17e',
    'fork-lift': '\ue17f',
    'fork-lift-locator': '\ue180',
    'forward-right': '\ue181',
    'forward-right-double': '\ue182',
    'full-empty': '\ue183',
    'fullscreen': '\ue184',
    'fullscreen-arrows': '\ue185',
    'fullscreen-exit': '\ue186',
    'g-arrow-down': '\ue187',
    'g-arrow-up': '\ue188',
    'generator': '\ue189',
    'gift': '\ue18a',
    'glance': '\ue18b',
    'glas-plate': '\ue18c',
    'globe': '\ue18d',
    'globe-arrow': '\ue18e',
    'glossary': '\ue18f',
    'grid-view': '\ue190',
    'hammer': '\ue191',
    'hand': '\ue192',
    'hand-motion': '\ue193',
    'hand-motion-off-disabled-light': '\ue194',
    'handlewithcare': '\ue195',
    'handover-add': '\ue196',
    'handover-check': '\ue197',
    'handover-remove': '\ue198',
    'hanger': '\ue199',
    'health': '\ue19a',
    'heart': '\ue19b',
    'history': '\ue19c',
    'home': '\ue19d',
    'home-locator': '\ue19e',
    'hourglass': '\ue19f',
    'hydrant': '\ue1a0',
    'ice': '\ue1a1',
    'imagery': '\ue1a2',
    'imagery-add': '\ue1a3',
    'imagery-remove': '\ue1a4',
    'import': '\ue1a5',
    'imprint': '\ue1a6',
    'impulse': '\ue1a7',
    'industry': '\ue1a8',
    'industry-clock': '\ue1a9',
    'industry-connected': '\ue1aa',
    'info': '\ue1ab',
    'info-i': '\ue1ac',
    'interval': '\ue1ad',
    'it-device': '\ue1ae',
    'jewel': '\ue1af',
    'keyboard': '\ue1b0',
    'label': '\ue1b1',
    'laptop': '\ue1b2',
    'laser': '\ue1b3',
    'layout': '\ue1b4',
    'leaf': '\ue1b5',
    'led': '\ue1b6',
    'brick': '\ue1b7',
    'brick-slanting-1': '\ue1b8',
    'brick-slanting-2': '\ue1b9',
    'less-minimize': '\ue1ba',
    'lightbulb': '\ue1bb',
    'lightbulb-off': '\ue1bc',
    'line-chart': '\ue1bd',
    'link': '\ue1be',
    'link-broken': '\ue1bf',
    'list-view': '\ue1c0',
    'list-view-mobile': '\ue1c1',
    'livechat': '\ue1c2',
    'locator': '\ue1c3',
    'locator-ip-connected': '\ue1c4',
    'locator-ip-disconnected': '\ue1c5',
    'locator-spot': '\ue1c6',
    'locator-spot-check': '\ue1c7',
    'lock-closed': '\ue1c8',
    'lock-open': '\ue1c9',
    'login': '\ue1ca',
    'logistics': '\ue1cb',
    'logout': '\ue1cc',
    'machine': '\ue1cd',
    'magnet': '\ue1ce',
    'mail': '\ue1cf',
    'mail-forward': '\ue1d0',
    'mail-open': '\ue1d1',
    'mail-out': '\ue1d2',
    'mail-reply': '\ue1d3',
    'male': '\ue1d4',
    'map': '\ue1d5',
    'material-add': '\ue1d6',
    'material-check': '\ue1d7',
    'material-remove': '\ue1d8',
    'maximize': '\ue1d9',
    'mechanic': '\ue1da',
    'megaphone': '\ue1db',
    'message': '\ue1dc',
    'mic': '\ue1dd',
    'microphone': '\ue1de',
    'microphone-classic': '\ue1df',
    'minimize': '\ue1e0',
    'money-currency': '\ue1e1',
    'money-dollar': '\ue1e2',
    'moneybag-currency': '\ue1e3',
    'moneybag-dollar': '\ue1e4',
    'monument': '\ue1e5',
    'moon': '\ue1e6',
    'motorcycle': '\ue1e7',
    'motorcycle-side-car': '\ue1e8',
    'motorcycle-side': '\ue1e9',
    'mouse': '\ue1ea',
    'mouse-left': '\ue1eb',
    'mouse-right': '\ue1ec',
    'mouth': '\ue1ed',
    'my-product': '\ue1ee',
    'new-way-work': '\ue1ef',
    'newsletter': '\ue1f0',
    'newspaper': '\ue1f1',
    'nose': '\ue1f2',
    'notepad': '\ue1f3',
    'notepad-edit': '\ue1f4',
    'notification': '\ue1f5',
    'notification-active': '\ue1f6',
    'notification-add': '\ue1f7',
    'notification-remove': '\ue1f8',
    'oil-car': '\ue1f9',
    'omnichannel': '\ue1fa',
    'options': '\ue1fb',
    'origami-boat': '\ue1fc',
    'pallete-car': '\ue1fd',
    'pallete-car-connected': '\ue1fe',
    'panel': '\ue1ff',
    'paperclip': '\ue200',
    'paperplane': '\ue201',
    'parking': '\ue202',
    'pause': '\ue203',
    'payment': '\ue204',
    'people': '\ue205',
    'petrol-station': '\ue206',
    'piggybank': '\ue207',
    'pin-classic': '\ue208',
    'pin-modern': '\ue209',
    'plane-side': '\ue20a',
    'play': '\ue20b',
    'plug-12v': '\ue20c',
    'podium-speaker': '\ue20d',
    'police': '\ue20e',
    'poop': '\ue20f',
    'post-it': '\ue210',
    'postal-code': '\ue211',
    'power': '\ue212',
    'print': '\ue213',
    'prototyping': '\ue214',
    'puzzle': '\ue215',
    'quad': '\ue216',
    'question': '\ue217',
    'radar': '\ue218',
    'radio': '\ue219',
    'radiotower': '\ue21a',
    'redirect': '\ue21b',
    'redo': '\ue21c',
    'reference': '\ue21d',
    'refresh': '\ue21e',
    'refresh-cloud': '\ue21f',
    'registration': '\ue220',
    'remote': '\ue221',
    'reset': '\ue222',
    'resolution': '\ue223',
    'robot': '\ue224',
    'robot-connected': '\ue225',
    'robothead': '\ue226',
    'rocket': '\ue227',
    'rotation': '\ue228',
    'rotation-360': '\ue229',
    'rotation-x-left': '\ue22a',
    'rotation-x-right': '\ue22b',
    'rotation-y-down': '\ue22c',
    'rotation-y-up': '\ue22d',
    'route': '\ue22e',
    'ruler': '\ue22f',
    'ruler-pen': '\ue230',
    'satellite': '\ue231',
    'save': '\ue232',
    'scale': '\ue233',
    'scissors': '\ue234',
    'search': '\ue235',
    'security': '\ue236',
    'security-check': '\ue237',
    'security-user': '\ue238',
    'sensor': '\ue239',
    'server': '\ue23a',
    'server-expansion': '\ue23b',
    'server-rate': '\ue23c',
    'service-agent': '\ue23d',
    'service-time': '\ue23e',
    'settings': '\ue23f',
    'settings-arrows': '\ue240',
    'settings-connected': '\ue241',
    'share': '\ue242',
    'shield-stop': '\ue243',
    'ship': '\ue244',
    'ship-side': '\ue245',
    'shoppingcart': '\ue246',
    'shoppingcart-add': '\ue247',
    'shoppingcart-switch': '\ue248',
    'signal-full': '\ue249',
    'signal-half': '\ue24a',
    'signal-lost': '\ue24b',
    'signpost': '\ue24c',
    'simcard': '\ue24d',
    'skyscraper': '\ue24e',
    'smartcity': '\ue24f',
    'smarthome': '\ue250',
    'smartphone': '\ue251',
    'smartphone-acoustic': '\ue252',
    'smartphone-arrow-right': '\ue253',
    'smartphone-arrows-x-y-z': '\ue254',
    'smartphone-clock': '\ue255',
    'smartphone-cloud': '\ue256',
    'smartphone-loading-wheel': '\ue257',
    'smartphone-smashed': '\ue258',
    'smartphone-vibration': '\ue259',
    'smartphone-z': '\ue25a',
    'smartwatch-connected': '\ue25b',
    'spare-parts': '\ue25c',
    'spark': '\ue25d',
    'speaker-acoustic': '\ue25e',
    'speedometer': '\ue25f',
    'stadium': '\ue260',
    'stairs': '\ue261',
    'stamp': '\ue262',
    'standby': '\ue263',
    'steering-wheel': '\ue264',
    'steering-wheel-connected': '\ue265',
    'steering-wheel-hands': '\ue266',
    'steps': '\ue267',
    'stethoscope': '\ue268',
    'stop': '\ue269',
    'stopwatch': '\ue26a',
    'storage-local': '\ue26b',
    'structure': '\ue26c',
    'subtitles': '\ue26d',
    'subtitles-off-light': '\ue26e',
    'summary': '\ue26f',
    'sun': '\ue270',
    'sun-half-filled': '\ue271',
    'sunshade-table': '\ue272',
    'surveillance': '\ue273',
    'table-chairs': '\ue274',
    'tablet': '\ue275',
    'team': '\ue276',
    'team-lightbulb': '\ue277',
    'technical-service': '\ue278',
    'temperature': '\ue279',
    'temperature-high': '\ue27a',
    'temperature-low': '\ue27b',
    'theater': '\ue27c',
    'thumb-down': '\ue27d',
    'thumb-up': '\ue27e',
    'ticket': '\ue27f',
    'touch': '\ue280',
    'touch-sos': '\ue281',
    'towing-truck': '\ue282',
    'train': '\ue283',
    'train-side': '\ue284',
    'transport-movements': '\ue285',
    'transscript': '\ue286',
    'transscript-off': '\ue287',
    'transscript-on': '\ue288',
    'tree': '\ue289',
    'tricycle': '\ue28a',
    'trolley-empty': '\ue28b',
    'trolley-filled-box': '\ue28c',
    'trolly-filled-files': '\ue28d',
    'trophy': '\ue28e',
    'truck': '\ue28f',
    'tuktuk': '\ue290',
    'tune': '\ue291',
    'typography': '\ue292',
    'ui': '\ue293',
    'umbrella': '\ue294',
    'undo': '\ue295',
    'up': '\ue296',
    'up-double': '\ue297',
    'up-down': '\ue298',
    'upload': '\ue299',
    'usb': '\ue29a',
    'user': '\ue29b',
    'user-advanced': '\ue29c',
    'user-beginner': '\ue29d',
    'user-desktop': '\ue29e',
    'user-down': '\ue29f',
    'user-falling': '\ue2a0',
    'user-hand': '\ue2a1',
    'user-hand-stop': '\ue2a2',
    'user-professional': '\ue2a3',
    'user-run': '\ue2a4',
    'user-share': '\ue2a5',
    'user-voice': '\ue2a6',
    'user-walk': '\ue2a7',
    'video': '\ue2a8',
    'video-disabled-light': '\ue2a9',
    'video-record': '\ue2aa',
    'virtual-reality': '\ue2ab',
    'volume-disabled': '\ue2ac',
    'volume-high': '\ue2ad',
    'volume-low': '\ue2ae',
    'volume-off-light': '\ue2af',
    'wand': '\ue2b0',
    'warranty': '\ue2b1',
    'watch-off-disabled-light': '\ue2b2',
    'watch-on': '\ue2b3',
    'water-shower': '\ue2b4',
    'welcome': '\ue2b5',
    'wellness': '\ue2b6',
    'wheelchair': '\ue2b7',
    'whistle': '\ue2b8',
    'wide-angled-arrow': '\ue2b9',
    'wifi': '\ue2ba',
    'window-analysis': '\ue2bb',
    'window-browser': '\ue2bc',
    'window-console': '\ue2bd',
    'window-gaussian-view': '\ue2be',
    'window-info': '\ue2bf',
    'window-new': '\ue2c0',
    'window-resize': '\ue2c1',
    'window-scaling-view': '\ue2c2',
    'window-shuffle': '\ue2c3',
    'window-statistic': '\ue2c4',
    'wishlist': '\ue2c5',
    'work-order': '\ue2c6',
    'worldwideweb': '\ue2c7',
    'wrench': '\ue2c8',
    'zoom-in': '\ue2c9',
    'zoom-out': '\ue2ca',
    'scooter': '\ue2cb',
    'cars-traffic': '\ue2cc',
    'arm-chair': '\ue2cd',
    'car-phone': '\ue2ce',
    'box-lightbulb': '\ue2cf',
    'chair-officedesk': '\ue2d0',
    'calendar-clock': '\ue2d1',
    'document-cv': '\ue2d2',
    'user-run-bag': '\ue2d3',
    'brake-disk-spray': '\ue2d4',
    'circle-abs': '\ue2d5',
    'bright-down': '\ue2d6',
    'bright-up': '\ue2d7',
    'fan': '\ue2d8',
    'sun-moon': '\ue2d9',
    'lightbulb-attention': '\ue2da',
    'settings-attention': '\ue2db',
    'danger-hazards': '\ue2dc',
    'windshield-spray': '\ue2dd',
    'windshield-heat': '\ue2de',
    'light-drop': '\ue2df',
    'starter': '\ue2e0',
    'turbo': '\ue2e1',
    'settings-lock': '\ue2e2',
    'settings-n': '\ue2e3',
    'light-beam-high': '\ue2e4',
    'light-beam-low': '\ue2e5',
    'glas': '\ue2e6',
    'shirt-ice': '\ue2e7',
    'helmet-fan': '\ue2e8',
    'notification-arrow': '\ue2e9',
    'steering-wheel-arrow': '\ue2ea',
    'circle-arrow': '\ue2eb',
    'tempomat-pit': '\ue2ec',
    'radiator-fan-spray': '\ue2ed',
    'boost-down': '\ue2ee',
    'boost-up': '\ue2ef',
    'circle-lock': '\ue2f0',
    'mp-down': '\ue2f1',
    'mp-up': '\ue2f2',
    'tc-down': '\ue2f3',
    'tc-up': '\ue2f4',
    'danger-arrow-attention': '\ue2f5',
    'user-remove': '\ue2f6',
    'user-add': '\ue2f7',
    'post-it-collection': '\ue2f8',
    'horn': '\ue2f9',
    'desktop-notification': '\ue2fa',
    'router': '\ue2fb',
    'berry': '\ue2fc',
    'chat-language': '\ue2fd',
    'game-controller': '\ue2fe',
    'user-brain': '\ue2ff',
    'mouth-finger': '\ue300',
    'excavator-shovel': '\ue301',
    'ear-in': '\ue302',
    'ear-out': '\ue303',
    'lion': '\ue304',
    'car-convertible': '\ue305',
    'car-sports': '\ue306',
    'bear': '\ue307',
    'pot': '\ue308',
    'bed-double': '\ue309',
    'air-hot': '\ue30a',
    'air-ice': '\ue30b',
    'air-leaf': '\ue30c',
    'air-purifier-0': '\ue30d',
    'air-purifier-1': '\ue30e',
    'air-purifier-2': '\ue30f',
    'air-purifier-3': '\ue310',
    'air': '\ue311',
    'fan-off-disabled-bold': '\ue312',
    'ice-off-disabled-bold': '\ue313',
    'faucet-boost': '\ue314',
    'faucet-mode': '\ue315',
    'faucet-off-disabled-bold': '\ue316',
    'faucet-schedule': '\ue317',
    'fuel-cell': '\ue318',
    'heating-floor-off-disabled-bold': '\ue319',
    'heating-floor': '\ue31a',
    'heating-radiator-boost': '\ue31b',
    'heating-radiator-mode': '\ue31c',
    'heating-radiator-off-disabled-bold': '\ue31d',
    'heating-radiator-schedule': '\ue31e',
    'leaf-simple': '\ue31f',
    'oil-barrel': '\ue320',
    'water-bathtub': '\ue321',
    'water-dishwash': '\ue322',
    'water-handwash': '\ue323',
    'water-hot': '\ue324',
    'water-ice': '\ue325',
    'water-leaf': '\ue326',
    'water-ladder': '\ue327',
    'water-purifier-0': '\ue328',
    'water-purifier-1': '\ue329',
    'water-purifier-2': '\ue32a',
    'water-purifier-3': '\ue32b',
    'water-shower-boost': '\ue32c',
    'water-shower-mode': '\ue32d',
    'water-shower-off-disabled-bold': '\ue32e',
    'water-shower-schedule': '\ue32f',
    'water': '\ue330',
    'chart-bar-drop': '\ue331',
    'chart-bar-fire': '\ue332',
    'chart-bar-flash': '\ue333',
    'chart-bar-oil': '\ue334',
    'drop-minus': '\ue335',
    'drop-plus': '\ue336',
    'fan-minus': '\ue337',
    'fan-plus': '\ue338',
    'home-drops-0': '\ue339',
    'home-drops-1': '\ue33a',
    'home-drops-2': '\ue33b',
    'home-drops-3': '\ue33c',
    'home-temperature-in': '\ue33d',
    'home-temperature-out': '\ue33e',
    'home-user-in': '\ue33f',
    'ice-minus': '\ue340',
    'ice-plus': '\ue341',
    'chimney-sweeper': '\ue342',
    'menu-up': '\ue343',
    'security-ice': '\ue344',
    'security-legionella': '\ue345',
    'trolley-case': '\ue346',
    'sun-minus': '\ue347',
    'sun-plug': '\ue348',
    'sun-plus': '\ue349',
    'touch-pit': '\ue34a',
    'temperature-current': '\ue34b',
    'temperature-set': '\ue34c',
    'teddy-bear': '\ue34d',
    'document-svg': '\ue34e',
    'back-menu': '\ue34f',
    'car-arrows': '\ue350',
    'wrench-cloud': '\ue351',
    'weather-cloud-sun': '\ue352',
    'weather-cloudy': '\ue353',
    'weather-gale': '\ue354',
    'weather-mist': '\ue355',
    'weather-moon-cloud': '\ue356',
    'weather-rain-snow': '\ue357',
    'weather-rain-thunder': '\ue358',
    'weather-rain': '\ue359',
    'weather-snow': '\ue35a',
    'weather-thunder': '\ue35b',
    'weather-wind': '\ue35c',
    'plane-start': '\ue35d',
    'plane-land': '\ue35e',
    'graph-power': '\ue35f',
    'floorplan': '\ue360',
    'clock-pause': '\ue361',
    'clock-start': '\ue362',
    'clock-stop': '\ue363',
    'computer-retro': '\ue364',
    'smartphone-retro': '\ue365',
    'wood': '\ue366',
    'solid-fuel': '\ue367',
    'appliance-fan': '\ue368',
    'appliance-flame': '\ue369',
    'appliance-ice': '\ue36a',
    'appliance-oil': '\ue36b',
    'appliance-solid-fuel': '\ue36c',
    'appliance-sun-ice': '\ue36d',
    'appliance-sun': '\ue36e',
    'appliance-wood': '\ue36f',
    'appliance-air-leaf': '\ue370',
    'appliance-water-air': '\ue371',
    'appliance-water-leaf': '\ue372',
    'appliance-water-oil': '\ue373',
    'appliance-water': '\ue374',
    'appliance-heat-pump-air': '\ue375',
    'appliance-heat-pump-ground': '\ue376',
    'appliance-heat-pump-water': '\ue377',
    'appliance-plug-air': '\ue378',
    'appliance-plug-fuel-cell': '\ue379',
    'appliance-plug-leaf': '\ue37a',
    'appliance-plug-water-air': '\ue37b',
    'thermostat-connected-c': '\ue37c',
    'thermostat-connected-f': '\ue37d',
    'image-gallery': '\ue37e',
    'arrows-caution': '\ue37f',
    'arrows-diagonal-disabled-bold': '\ue380',
    'back-left-end': '\ue381',
    'back-right-end': '\ue382',
    'bar-chart-search': '\ue383',
    'batch': '\ue384',
    'calendar-remove': '\ue385',
    'call-bluetooth': '\ue386',
    'call-deny': '\ue387',
    'call-settings': '\ue388',
    'caution-sign-clock': '\ue389',
    'caution-sign-list': '\ue38a',
    'core-data': '\ue38b',
    'cursor-connected': '\ue38c',
    'cursor': '\ue38d',
    'dmc-code': '\ue38e',
    'find-id': '\ue38f',
    'globe-search': '\ue390',
    'interface': '\ue391',
    'material-add-manually': '\ue392',
    'material-list': '\ue393',
    'material-remove-manually': '\ue394',
    'material': '\ue395',
    'menu-checkmark': '\ue396',
    'qr-code': '\ue397',
    'sort-alphabetically': '\ue398',
    'unpin-classic-disabled-bold': '\ue399',
    'unpin-modern-disabled-bold': '\ue39a',
    'window-search': '\ue39b',
    'cloud-clock': '\ue39c',
    'concierge': '\ue39d',
    'heating-radiator': '\ue39e',
    'home-user-out': '\ue39f',
    'hot': '\ue3a0',
    'screen-service': '\ue3a1',
    'sun-ice': '\ue3a2',
    'sun-off-disabled-bold': '\ue3a3',
    'tractor': '\ue3a4',
    'video-recorder-digital': '\ue3a5',
    'windshield-wiper': '\ue3a6',
    'weather-snow-thunder': '\ue3a7',
    'electricity-pylon': '\ue3a8',
    'box-questionmark': '\ue3a9',
    'rainbow': '\ue3aa',
    'medal': '\ue3ab',
    'wheel': '\ue3ac',
    'borescope-connected': '\ue3ad',
    'filter-delete': '\ue3ae',
    'filter-add': '\ue3af',
    'man': '\ue3b0',
    'woman': '\ue3b1',
    'fridge': '\ue3b2',
    'battery-car': '\ue3b3',
    'bag-escalator': '\ue3b4',
    'shopping-bags': '\ue3b5',
    'car-steering-left': '\ue3b6',
    'car-steering-right': '\ue3b7',
    'thumb-up-down': '\ue3b8',
    'user-run-detection': '\ue3b9',
    'bank': '\ue3ba',
    'transportation': '\ue3bb',
    'government': '\ue3bc',
    'user-music': '\ue3bd',
    'bus': '\ue3be',
    'car-euro': '\ue3bf',
    'bag': '\ue3c0',
    'plate-tetrapack': '\ue3c1',
    'hospital': '\ue3c2',
    'desktop-structure': '\ue3c3',
    'frog-head': '\ue3c4',
    'sportboat': '\ue3c5',
    'yacht': '\ue3c6',
    'leaf-tilia': '\ue3c7',
    'music': '\ue3c8',
    'oil-lamp': '\ue3c9',
    'windshield-wiper-rear': '\ue3ca',
    'dongle-connected': '\ue3cb',
    'slate': '\ue3cc',
    'appliance-heat-pump-exhaust': '\ue3cd',
    'alert-list': '\ue3ce',
    'arrow-left-end-frame': '\ue3cf',
    'arrow-right-end-frame': '\ue3d0',
    'shape-ellipse': '\ue3d1',
    'shape-rectangle': '\ue3d2',
    'wishlist-add': '\ue3d3',
    'smartphone-disabled-light': '\ue3d4',
    'airbag': '\ue3d5',
    'compass': '\ue3d6',
    'turbine-wind': '\ue3d7',
    'arrows-diagonal-disabled-light': '\ue3d8',
    'ear-off-disabled-bold': '\ue3d9',
    'fan-off-disabled-light': '\ue3da',
    'faucet-off-disabled-light': '\ue3db',
    'hand-motion-off-disabled-bold': '\ue3dc',
    'heating-floor-off-disabled-light': '\ue3dd',
    'heating-radiator-off-disabled-light': '\ue3de',
    'ice-off-disabled-light': '\ue3df',
    'smartphone-disabled-bold': '\ue3e0',
    'subtitles-off-bold': '\ue3e1',
    'sun-off-disabled-light': '\ue3e2',
    'video-disabled-bold': '\ue3e3',
    'volume-off-bold': '\ue3e4',
    'watch-off-disabled-bold': '\ue3e5',
    'water-shower-off-disabled-light': '\ue3e6',
    '3d-frame-play': '\ue3e7',
    'alert-error-checkmark': '\ue3e8',
    'arrow-up-frame-check': '\ue3e9',
    'arrow-up-frame-error': '\ue3ea',
    'arrows-checkmark': '\ue3eb',
    'assembly-line-settings': '\ue3ec',
    'augmented-reality-player': '\ue3ed',
    'badge-checkmark': '\ue3ee',
    'bar-chart-kappa': '\ue3ef',
    'bar-chart-search-detail': '\ue3f0',
    'barcode-checkmark': '\ue3f1',
    'barcode-scan-bulb': '\ue3f2',
    'barcode': '\ue3f3',
    'binary': '\ue3f4',
    'book-lightbulb': '\ue3f5',
    'box-arrow-down': '\ue3f6',
    'box-delivery-checkmark': '\ue3f7',
    'globe-checkmark': '\ue3f8',
    'calendar-boxes': '\ue3f9',
    'calendar-service': '\ue3fa',
    'camera-processor': '\ue3fb',
    'camera-settings': '\ue3fc',
    'chart-line-checkmark': '\ue3fd',
    'checklist-stack': '\ue3fe',
    'checkmark-frame-minimum': '\ue3ff',
    'checkmark-frame-tripple': '\ue400',
    'clipboard-checkmark': '\ue401',
    'clipboard-list-parts': '\ue402',
    'clipboard-settings': '\ue403',
    'computer-tower-box': '\ue404',
    'connectivity-lock': '\ue405',
    'counter-current': '\ue406',
    'counter-target': '\ue407',
    'cube-checkmark': '\ue408',
    'cube-play': '\ue409',
    'time-line-settings': '\ue40a',
    'time-line-view': '\ue40b',
    'time-line': '\ue40c',
    'delivery-checkmark': '\ue40d',
    'desktop-application-3d-play': '\ue40e',
    'desktop-apps-download': '\ue40f',
    'desktop-dashboard': '\ue410',
    'desktop-graph-checkmark': '\ue411',
    'desktop-graph-search': '\ue412',
    'desktop-graph': '\ue413',
    'development-kit': '\ue414',
    'directory-cloud-settings': '\ue415',
    'directory-cloud': '\ue416',
    'directory-settings': '\ue417',
    'document-clock-cycle': '\ue418',
    'document-code-stack': '\ue419',
    'document-dat-edit': '\ue41a',
    'document-ohd-arrow-down': '\ue41b',
    'dolphin': '\ue41c',
    'energy-management': '\ue41d',
    'eraser': '\ue41e',
    'folder-broom': '\ue41f',
    'folder-check-broom': '\ue420',
    'folder-checkmark': '\ue421',
    'folder-oes-check': '\ue422',
    'folder-open-service': '\ue423',
    'folder-reload': '\ue424',
    'hand-command': '\ue425',
    'heating-start': '\ue426',
    'hierarchy-refresh': '\ue427',
    'hierarchy-search': '\ue428',
    'hierarchy-settings': '\ue429',
    'hierarchy': '\ue42a',
    'hmi-desktop-settings': '\ue42b',
    'human-machine-interface': '\ue42c',
    'keys-user-access': '\ue42d',
    'keys': '\ue42e',
    'label-edit': '\ue42f',
    'line-arrow-checkmark': '\ue430',
    'link-checkmark': '\ue431',
    'lock-closed-checkmark': '\ue432',
    'lock-open-checkmark': '\ue433',
    'material-search': '\ue434',
    'objects-search': '\ue435',
    'objects': '\ue436',
    'plan-a-to-b': '\ue437',
    'plan-chart': '\ue438',
    'print-send': '\ue439',
    'refresh-analysis': '\ue43a',
    'remote-desktop-add': '\ue43b',
    'rfid-checkmark': '\ue43c',
    'rfid-tag': '\ue43d',
    'sequence-checkmark': '\ue43e',
    'server-arrow-up': '\ue43f',
    'server-arrows': '\ue440',
    'server-settings': '\ue441',
    'server-share': '\ue442',
    'settings-editor': '\ue443',
    'survey-checkmark': '\ue444',
    'target-dart': '\ue445',
    'target-view': '\ue446',
    'target': '\ue447',
    'thickness-selection': '\ue448',
    'toolbox-checkmark': '\ue449',
    'toolbox': '\ue44a',
    'translate': '\ue44b',
    'tune-vertical-checkmark': '\ue44c',
    'wand-user-add': '\ue44d',
    'wand-user-settings': '\ue44e',
    'wand-user': '\ue44f',
    'window-globe': '\ue450',
    'wrench-change': '\ue451',
    'clock-24-7': '\ue452',
    'eagle': '\ue453',
    'fluorescent-light': '\ue454',
    'home-cloud-0': '\ue455',
    'home-cloud-1': '\ue456',
    'home-cloud-2': '\ue457',
    'home-cloud-3': '\ue458',
    'home-shadow': '\ue459',
    'motorcycle-sport': '\ue45a',
    'smartphone-connected': '\ue45b',
    'usb-stick': '\ue45c',
    'user--setting': '\ue45d',
    'time-line-clock': '\ue45e',
    'alarm-fire': '\ue45f',
    'emergency-front': '\ue460',
    'transporter-front': '\ue461',
    'truck-front': '\ue462',
    'unpin-classic-disabled-light': '\ue463',
    'unpin-modern-disabled-light': '\ue464',
    'smartphone-ban': '\ue465',
    'helmet': '\ue466',
    'gate-closed': '\ue467',
    'fence': '\ue468',
    'desktop-apps': '\ue469',
    'candle': '\ue46a',
    'abort-frame': '\ue886',
    'arrow-down-frame': '\ue887',
    'arrow-left-down-frame': '\ue888',
    'arrow-left-frame': '\ue889',
    'arrow-left-up-frame': '\ue88a',
    'arrow-right-down-frame': '\ue88b',
    'arrow-right-frame': '\ue88c',
    'arrow-right-up-frame': '\ue88d',
    'arrow-up-frame': '\ue88e',
    'asiapacific-frame': '\ue88f',
    'cash-frame': '\ue890',
    'checkmark-frame': '\ue891',
    'copyright-frame': '\ue892',
    'download-frame': '\ue893',
    'europe-frame': '\ue894',
    'lock-closed-frame': '\ue895',
    'lock-open-frame': '\ue896',
    'my-brand-frame': '\ue897',
    'northamerica-frame': '\ue898',
    'problem-frame': '\ue899',
    'promotion-frame': '\ue89a',
    'question-frame': '\ue89b',
    'share-frame': '\ue89c',
    'southamerica-frame': '\ue89d',
    'start-play-frame': '\ue89e',
    'upload-frame': '\ue89f',
    'world-frame': '\ue8a0',
    'add-frame': '\ue8a1',
    'call-deny-frame': '\ue8a2',
    'call-frame': '\ue8a3',
    'fast-backward-frame': '\ue8a4',
    'fast-forward-frame': '\ue8a5',
    'skip-backward-frame': '\ue8a6',
    'skip-fast-backward-frame': '\ue8a7',
    'skip-fast-forward-frame': '\ue8a8',
    'skip-forward-frame': '\ue8a9',
    'subtract-frame': '\ue8aa',
    'facebook-frame': '\uea87',
    'googleplus-frame': '\uea88',
    'instagram-frame': '\uea89',
    'lineapp-frame': '\uea8a',
    'linkedin-frame': '\uea8b',
    'pinterest-frame': '\uea8c',
    'snapchat-frame': '\uea8d',
    'tumblr-frame': '\uea8e',
    'twitter-frame': '\uea8f',
    'vimeo-frame': '\uea90',
    'wechat-frame': '\uea91',
    'weibo-frame': '\uea92',
    'whatsapp-frame': '\uea93',
    'xing-frame': '\uea94',
    'youku-frame': '\uea95',
    'youtube-frame': '\uea96',
    'vk-frame': '\uea97',
    'skype-frame': '\uea98',
    'alert-error-filled': '\ueb08',
    'alert-error': '\ueb09',
    'alert-success-filled': '\ueb0a',
    'alert-success': '\ueb0b',
    'alert-warning-filled': '\ueb0c',
    'alert-warning': '\ueb0d'
  };

  const getIcon = (name) => {
    return iconsMap[name] || '';
  };

  const defaultStyles = StyleSheet.create({
    defaults: {
      fontFamily: 'BoschIcons',
      color: iconColor,
      fontSize: iconSize,
      lineHeight: iconSize
    }
  });

  const finalStyles = props.style ? [defaultStyles.defaults, props.style] : [defaultStyles.defaults];

  if(isLoaded('BoschIcons')) {
    return (
      <Text style={finalStyles}>{getIcon(iconName)}</Text>
    )
  } else {
    return null
  }
}
